import {LocalizationData} from "../components/localization/LocalizedText";
import {Subtitles} from "../components/localization/LocalizedSubtitles";

const cookbookLanguages: {[language: string]: string} = {
    englishUS: "English(US)",
    arabic: "Arabic",
    brazilianPortuguese: "Portuguese(Brazil)",
    bulgarian: "Bulgarian",
    dutch: "Dutch",
    french: "French",
    german: "German",
    greek: "Greek",
    hungarian: "Hungarian",
    italian: "Italian",
    mexicanSpanish: "Spanish(Latin America)",
    polish: "Polish",
    portuguese: "Portuguese(Portugal)",
    russian: "Russian",
    spanish: "Spanish(Spain)",
    chineseSimplified: "Chinese(Simplified)",
    chineseTraditional: "Chinese(Traditional)",
};

const cookbookLanguageTags: {[tag: string]: string} = {
    english: "en",
    englishUS: "us",                           
    arabic: "Arab",
    brazilianPortuguese: "BrPt",
    bulgarian: "bu",
    dutch: "nl",
    french: "fr",
    german: "Deut",
    greek: "el",
    hungarian: "hu",
    italian: "Ital",
    mexicanSpanish: "EsMx",
    polish: "pl",
    portuguese: "Port",
    russian: "Russ",
    spanish: "es",
    chineseSimplified: "zh-hans",
    chineseTraditional: "zh-hant",
};

export function exportLocalizationStrings(localization: LocalizationData) {
    const exported: {[key: string]: any} = {
        version: 1,
        KEY: ["English(UK)", "English(UK)", ...Object.values(cookbookLanguages)]
    };
    Object.keys(localization).forEach(key => {
        exported[key] = [
            localization[key].english.text,
            localization[key].english.text,
            ...Object.keys(cookbookLanguages).map(language =>localization[key][language]?.text || "")
        ]
    });
    return exported;
}

export function exportSubtitles(subtitles: Subtitles) {
    const exported: {[key: string]: any} = Object.fromEntries(Object.values(cookbookLanguageTags)
        .map(language => [language, {}]));

    Object.entries(subtitles).forEach(([key, subtitles]) => 
        exported.en[key] = Object.fromEntries(Object.entries(cookbookLanguageTags)
            .map(([language, tag]) =>
                language === "english" ? [tag, subtitles.cues || []] :
                    [tag, subtitles.languages ? subtitles.languages[language]?.cues: []]
            )
        )
    );
    return exported;
}
